export const getClusterId = () : string => {


  const configEl: HTMLElement = document.querySelector('[data-app-layer-config-search]');


  if (!configEl) {

    return '';
  }



  let config;
  try {
    config = JSON.parse(configEl.dataset.appLayerConfigSearch);
  } catch (e) {

    return '';
  }



  if (!config) {

    return '';
  }


  return config.clusterId;

}

export const getMarket = () : string => {
  // For now we just have a single market, in the future if we need additional logic it can be added here
  return 'NFD';
}

export const getLocale = () : string => {
  // For now we just have a single locale, in the future if we need additional logic it can be added here
  return 'en-GB';
}

export const getTouchpoint = () : 'desktop' | 'mobile' => {
  return window.matchMedia('(min-width: 1024px)').matches ? 'desktop' : 'mobile'
  // return 'desktop';
}

export const getViewId = () : 'production' | 'preview' => {
  return 'production';
}

/**
 * Check if user has consented to cookies via Shopify Customer Privacy API or custom cookie
 * Returns true if analytics or marketing consent is allowed, or if our custom suppression cookie is set
 */
export const hasCookieConsent = (): boolean => {
  const logPrefix = '🕵️ [hasCookieConsent]';
  try {
    const rawCookies = document.cookie;

    // 1. Check for our custom cookie banner suppression cookie
    const hasCustomCookie = rawCookies.indexOf('cookieMonsterSuppressed=true') !== -1;
    if (hasCustomCookie) {
      console.log(`${logPrefix} ✅ Found 'cookieMonsterSuppressed=true'`);
      return true;
    }

    // 2. Check Shopify Customer Privacy API
    const shopify = (window as any).Shopify;
    const cp = shopify?.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
      const analyticsAllowed = cp.analyticsProcessingAllowed();
      const marketingAllowed = cp.marketingAllowed ? cp.marketingAllowed() : false;
      const result = analyticsAllowed || marketingAllowed;

      if (result) {
        console.log(`${logPrefix} ✅ Shopify API Match | Analytics: ${analyticsAllowed}, Marketing: ${marketingAllowed}`);
        return true;
      } else {
        console.log(`${logPrefix} ℹ️ Shopify API found but consent is false`);
      }
    }

    // 3. Check for Pandectes
    const pandectes = (window as any).Pandectes;
    if (pandectes && typeof pandectes.getConsent === 'function') {
      const consent = pandectes.getConsent();
      if (consent && (consent.statistics || consent.marketing)) {
        logOnce(`${logPrefix} ✅ Pandectes consent found: ${JSON.stringify(consent)}`);
        return true;
      } else {
        logOnce(`${logPrefix} ℹ️ Pandectes found but categories (statistics/marketing) are false. Full object: ${JSON.stringify(consent)}`);
      }
    }

    // 4. Fallback: Search for ANY cookie that looks like explicit consent
    const commonConsentKeywords = ['cookie-consent=true', 'accepted-cookies=true'];
    const foundFallback = commonConsentKeywords.find(keyword => rawCookies.indexOf(keyword) !== -1);

    if (foundFallback) {
      logOnce(`${logPrefix} ✅ Found common fallback/active cookie: ${foundFallback}`);
      return true;
    }

    // 5. Deep Pandectes Cookie Parse (Fallback if API is slow)
    if (rawCookies.indexOf('_pandectes_gdpr=') !== -1) {
      try {
        const pCookie = rawCookies.split('_pandectes_gdpr=')[1].split(';')[0];
        const decoded = JSON.parse(atob(pCookie));
        const hasDirectConsent = decoded?.status === 'allow' || decoded?.preferences?.statistics || decoded?.preferences?.marketing;

        if (hasDirectConsent) {
          logOnce(`${logPrefix} ✅ Found Pandectes consent in cookie directly: ${JSON.stringify(decoded)}`);
          return true;
        } else if (pCookie) {
          logOnce(`${logPrefix} ℹ️ Pandectes cookie found but categories are false. Cookie Content: ${JSON.stringify(decoded)}`);
        }
      } catch (e) {
        // Silently fail cookie parse fallback
      }
    }

    logOnce(`${logPrefix} ❌ No consent found.
      Cookies (first 100): "${rawCookies.substring(0, 100)}..."
      Shopify CP: ${cp ? (cp.analyticsProcessingAllowed ? cp.analyticsProcessingAllowed() : 'f') : 'absent'}
      Pandectes API: ${pandectes ? (typeof pandectes.getConsent === 'function' ? 'has-fn' : 'no-fn') : 'absent'}
    `);
    return false;
  } catch (error) {
    console.warn(`${logPrefix} 🛑 Error:`, error);
    return false;
  }
}

// Simple throttle to prevent console log flood
const lastLogs = new Map<string, number>();
const logOnce = (msg: string, interval = 5000) => {
  const now = Date.now();
  const last = lastLogs.get(msg) || 0;
  if (now - last > interval) {
    console.log(msg);
    lastLogs.set(msg, now);
  }
};

/**
 * Generate a random string for session keys
 */
const generateRandomKey = (): string => {
  return Math.random().toString(36).substring(2, 15) +
         Math.random().toString(36).substring(2, 15);
}

/**
 * Generate ephemeral session keys that are stable for the lifetime of this function instance
 * Used when cookies are declined to avoid persisting user identifiers across browser restarts
 * but maintaining continuity for the current session.
 */
export const generateEphemeralSession = () => {
  const customerKey = generateRandomKey();
  const sessionKey = generateRandomKey();

  return () => ({
    customerKey,
    sessionKey
  });
}

/**
 * Get the appropriate session function based on cookie consent
 * Returns ephemeral session (stable for current instance) if cookies declined
 * Returns localStorage-backed session (persisted) if cookies accepted
 */
export const getVoyadoSession = (localStorageBackedSession: () => () => { customerKey: string; sessionKey: string }) => {
  if (hasCookieConsent()) {
    return localStorageBackedSession();
  } else {
    // Note: We return a stable instance of the ephemeral session
    // to ensure continuity for tracking within the same page session
    if (!(window as any).blubolt?.Voyado?._ephemeralSession) {
      if (!(window as any).blubolt) (window as any).blubolt = {};
      if (!(window as any).blubolt.Voyado) (window as any).blubolt.Voyado = {};
      (window as any).blubolt.Voyado._ephemeralSession = generateEphemeralSession();
    }
    return (window as any).blubolt.Voyado._ephemeralSession;
  }
}

/**
 * Listen for customerKey updates from Liquid script and ensure session is refreshed
 * This handles the case where localStorage is updated after Voyado API has already initialized
 */
export const setupCustomerKeySync = (localStorageBackedSession: () => () => { customerKey: string; sessionKey: string }) => {
  const refreshSession = (reason: string) => {
    if (hasCookieConsent()) {
      try {
        const session = localStorageBackedSession();
        const updatedKeys = session();
        console.info(`[Voyado] Session refreshed due to ${reason}. Current customerKey:`, updatedKeys.customerKey);
        // Dispatch an internal event so other components can react if needed
        window.dispatchEvent(new CustomEvent('voyado:sessionRefreshed', { detail: { reason, customerKey: updatedKeys.customerKey } }));
      } catch (error) {
        console.warn(`[Voyado] Error refreshing session after ${reason}:`, error);
      }
    }
  }

  // Listen for custom customer key updates (from theme.liquid sync)
  window.addEventListener('voyado:customerKeyUpdated', () => refreshSession('customerKey update'));

  // Listen for Shopify Customer Privacy API changes
  document.addEventListener('shopify:customerprivacy:allset', () => refreshSession('Shopify consent change'));

  // Listen for Pandectes consent changes
  document.addEventListener('pandectes:consent:updated', () => refreshSession('Pandectes consent updated'));
  document.addEventListener('pandectes:consent:ready', () => refreshSession('Pandectes consent ready'));
};